import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import * as dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en'; // todo Localize - split imports

@Injectable({
  providedIn: 'root',
})
export class InitLangService {

  constructor(
    @Inject(LOCALE_ID) public locale: string,
  ) {
  }

  init() {
    dayjs.locale(this.locale);
  }
}
